module.exports = __webpack_public_path__ + "static/media/DSCF0017.0fec0afd.jpg";